import React, { useState, useEffect } from 'react'
import TextInput from './TextInput'
import { FaCaretDown, FaCaretUp, FaTimes } from 'react-icons/fa' // Import FaTimes for 'X' icon
import { initialSingleReview } from '../../Data/StaticPersonandMoviedata'
import { Auth } from 'aws-amplify'
import Updateperson from '../../../Services/Mutations/Updateperson'
import { ToastStyle } from '../../Data/MovieStaticData'
import { toast } from 'react-toastify'

const ArticleReviewForm = ({
  personData,
  section,
  activeSection,
  handleSectionClick,
  reviews,
  setReviews,
  getUpdatedData,
  setLoader,
}) => {
  // const [reviews, setReviews] = useState([initialSingleReview])
  const [isSaveDisabled, setIsSaveDisabled] = useState(true)
  const [initalRender, setIntialRender] = useState(true)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleChange = (e, index) => {
    const { name, value } = e.target
    const reviewsTemp = [...reviews]
    reviewsTemp[index] = { ...reviewsTemp[index], [name]: value }
    setReviews(reviewsTemp)
  }

  const onAddReview = () => {
    setReviews([...reviews, initialSingleReview])
  }

  const onCancel = () => {
    getUpdatedData()
    setIntialRender(true)
    setIsSaveDisabled(true)
    // setReviews([initialSingleReview])
  }

  const onSave = async () => {
    setLoader(true)
    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
      yousayArticleReviews: reviews.map(review => {
        const { __typename, ...rest } = review // Destructure to remove __type
        return rest // Return the object without __typename
      }),
    }

    try {
      const upadatelog = await Updateperson(input)
      if (upadatelog.statusCode === 'A002') {
        toast.success('Updated person successfully', ToastStyle)
        getUpdatedData()
        setLoader(false)
        setIntialRender(true)
        setIsSaveDisabled(true)
        // return upadatelog
      }
    } catch (error) {
      setLoader(false)
      // setIntialRender(true)
      // setIsSaveDisabled(true)
      console.warn(error)
    }
  }

  const onRemoveReview = index => {
    const updatedReviews = [...reviews]
    updatedReviews.splice(index, 1)
    setReviews(updatedReviews)
  }

  useEffect(() => {
    if (!initalRender) {
      const allFieldsFilled = reviews.every(
        review =>
          review.articleReviewTitle_En &&
          review.articleReviewTitle_Te &&
          review.articleReviewURL_En &&
          review.articleReviewURL_Te,
      )
      if (reviews.length === 0) {
        setIsSaveDisabled(true)
      } else {
        setIsSaveDisabled(!allFieldsFilled)
      }
    }

    setIntialRender(false)
  }, [reviews])

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      {/* Accordion header */}
      <h2 className='accordion-header' id='headingThree'>
        {/* Button to toggle the accordion */}
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseThree'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          <span>Articles</span>
          {/* Display the caret icon based on the accordion state */}
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseThree'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingThree'
        data-bs-parent='#accordion'
      >
        <div className='container mt-4'>
          {reviews.map((review, index) => (
            <div key={index} className='border rounded p-3 mb-3 position-relative'>
              {/* X button for remove */}
              <button
                type='button'
                className='position-absolute top-0 end-0 m-2 rounded'
                style={{ zIndex: 10 }}
                onClick={() => onRemoveReview(index)}
              >
                <FaTimes />
              </button>
              <div className='row'>
                <div className='col-md-6'>
                  <TextInput
                    label='Title in English'
                    name='articleReviewTitle_En'
                    value={review.articleReviewTitle_En}
                    onChange={event => handleChange(event, index)}
                    placeholder='Title in English'
                  />
                  <TextInput
                    label='URL in English'
                    name='articleReviewURL_En'
                    value={review.articleReviewURL_En}
                    onChange={event => handleChange(event, index)}
                    placeholder='URL in English'
                  />
                </div>
                <div className='col-md-6'>
                  <TextInput
                    label='Title in Telugu'
                    name='articleReviewTitle_Te'
                    value={review.articleReviewTitle_Te}
                    onChange={event => handleChange(event, index)}
                    placeholder='Title in Telugu'
                  />
                  <TextInput
                    label='URL in Telugu'
                    name='articleReviewURL_Te'
                    value={review.articleReviewURL_Te}
                    onChange={event => handleChange(event, index)}
                    placeholder='URL in Telugu'
                  />
                </div>
              </div>
            </div>
          ))}
          <button type='button' className='btn btn-primary' onClick={onAddReview}>
            Add
          </button>
          <div className='d-flex justify-content-center align-items-center mt-3'>
            <button
              type='button'
              className='btn btn-success me-2'
              onClick={onSave}
              disabled={isSaveDisabled}
            >
              Save
            </button>
            <button type='button' className='btn btn-secondary' onClick={onCancel}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleReviewForm
